import script from "./DoctorPayoutConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoctorPayoutConfig.vue?vue&type=script&setup=true&lang=ts"

import "./DoctorPayoutConfig.vue?vue&type=style&index=0&id=079c9ffa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-079c9ffa"]])

export default __exports__